/** Generate a Grid ID */
function getGridId(uuid) {
    return `fpl-${uuid}-grid`;
}
/** Generate a listbox ID */
function getPopupId(uuid) {
    return `fpl-${uuid}-popup`;
}
/** Generate a listbox ID */
function getListboxId(uuid) {
    return `fpl-${uuid}-listbox`;
}
/** Generate Option ID */
function getOptionId({ uuid, localId }) {
    return `fpl-${uuid}-option-${localId}`;
}

export { getGridId, getListboxId, getOptionId, getPopupId };
//# sourceMappingURL=autocomplete-primitive.utils.js.map
